<template>
  <div class="q2" :class="{ fade: fade }">
    <div class="content">
      <AppBar></AppBar>
      <img
        class="q-index"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q2-head"
      />
      <div class="q-title animate__animated animate__fadeInDown">你的年龄</div>
      <div class="q-box">
        <div class="age-content">
          <input
            class="age-input"
            v-model="curAge"
            type="number"
            placeholder="请在这里填写"
          />
          <div
            class="iconfont icon-gou"
            :class="{ 'disabled-icon': curAge == '' }"
            @click="bindNext"
          ></div>
        </div>
      </div>
      <div class="q-next" v-if="curAge !== ''" @click="bindNext">下一步</div>
    </div>
  </div>
</template>
<script>
import QBtn from './q-btn.vue'
import AppBar from '../app-bar.vue'
export default {
  components: {
    QBtn,
    AppBar
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      disabled: true,
      fade: false,
      curAge: '',
      minAge: 12,
      maxAge: 70
    }
  },
  watch: {},
  created() {
    this.updateAge(this.data[this.index].value)
    this.$buryPoint('BG_XRWJ_WT2', {})
  },
  methods: {
    updateAge(value) {
      this.curAge = value
    },
    bindNext() {
      console.log(this.checkAge(this.curAge))
      if (!this.checkAge(this.curAge)) {
        return
      }
      this.data[this.index].value = this.curAge
      this.fade = true
      setTimeout(() => {
        this.$emit('next')
      }, 500)
    },
    checkAge(age) {
      if (age === '') {
        this.$toast('年龄不能为空')
        return false
      }
      var reg = /^[0-9]+[0-9]*$/
      if (!reg.test(age)) {
        this.$toast('年龄不能为非整数')
        return false
      }
      if (age < this.minAge || age > this.maxAge) {
        this.$toast('年龄需在' + this.minAge + '-' + this.maxAge + '之间')
        return false
      }
      return true
    }
  }
}
</script>
<style lang="scss" scoped>
.q2 {
  opacity: 1;
  transition: opacity 0.5s linear;
  position: relative;
  overflow-y: scroll;
  width: 100%;
  min-height: 100vh;
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q1-bg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  .content {
    overflow: hidden;
  }
  .q-index {
    width: 328px;
    margin: 7px auto 13px;
    height: 61px;
  }
  .q-title {
    text-align: center;
    font-size: 24px;
    font-family: MaoKenTangYuan-beta, MaoKenTangYuan;
    font-weight: 600;
    color: #000000;
    line-height: 34px;
    margin-bottom: 49px;
  }
  .q-box {
    height: 350px;
    .age-content {
      display: flex;
      align-items: center;
      .age-input {
        margin-left: 87px;
        width: 200px;
        height: 44px;
        border: none;
        outline: none;
        padding: 0px 50px;
        box-sizing: border-box;
        background: rgba(255, 255, 255, 0.9);
        border-radius: 22px;
        margin-right: 13px;
      }
      .iconfont {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-weight: 600;
        font-size: 18px;
        width: 34px;
        height: 34px;
        border-radius: 50%;
        background: #6236ff;
      }
      .disabled-icon {
        background-color: #999;
      }
    }
  }
  .q-next {
    margin: 0 auto 57px;
    text-align: center;
    line-height: 40px;
    font-weight: 600;
    width: 274px;
    height: 42px;
    box-sizing: border-box;
    border-radius: 22px;
    border: 2px solid rgba(0, 0, 0, 0.9);
  }
}
.fade {
  opacity: 0;
}
@keyframes myrotate {
  0% {
    transform: translateY(100px);
  }
  100% {
    transform: translateY(0px);
  }
}
</style>
